import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { KwikspaceService } from 'src/app/services/kwikspace.service';
import { CreateProductConfigurationFailure, CreateProductConfigurationSuccess, GetPagedProductListFailure, GetPagedProductListSuccess, GetProductConfigurationFailure, GetProductConfigurationSuccess, GetProductListFailure, GetProductListSuccess, ProductActionTypes, UpdateProductConfigurationFailure, UpdateProductConfigurationSuccess } from "../actions/product.action";

@Injectable()
export class ProductEffects {
  public constructor(
    private actions$: Actions,
    private service: KwikspaceService
  ) { }

  @Effect()
  GetProductList$: Observable<any> = this.actions$.pipe(
    ofType(ProductActionTypes.GET_PRODUCT_LIST),
    switchMap((action: any) => {
      return this.service.getProductList(action.payload).pipe(
        map((res: any) => new GetProductListSuccess(res)),
        catchError((error) => of(new GetProductListFailure(error)))
      );
    })
  );
  
  @Effect()
  GetPagedProductList$: Observable<any> = this.actions$.pipe(
    ofType(ProductActionTypes.GET_PAGED_PRODUCT_LIST),
    switchMap((action: any) => {
      return this.service.getPagedProductList(action.payload).pipe(
        map((res: any) => new GetPagedProductListSuccess(res)),
        catchError((error) => of(new GetPagedProductListFailure(error)))
      );
    })
  );

  @Effect()
  GetProductConfiguration$: Observable<any> = this.actions$.pipe(
    ofType(ProductActionTypes.GET_PRODUCT_CONFIGURATION),
    switchMap((action: any) => {
      return this.service.getProductConfiguration().pipe(
        map((res: any) => new GetProductConfigurationSuccess(res.results)),
        catchError((error) => of(new GetProductConfigurationFailure(error)))
      );
    })
  );

  @Effect()
  CreateProductConfiguration$: Observable<any> = this.actions$.pipe(
    ofType(ProductActionTypes.CREATE_PRODUCT_CONFIGURATION),
    switchMap((action: any) => {
      return this.service.createProductConfiguration(action.payload).pipe(
        map((res: any) => new CreateProductConfigurationSuccess(res)),
        catchError((error) => of(new CreateProductConfigurationFailure(error)))
      );
    })
  );

  @Effect()
  UpdateProductConfiguration$: Observable<any> = this.actions$.pipe(
    ofType(ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION),
    switchMap((action: any) => {
      return this.service.updateProductConfiguration(action.payload, action.id).pipe(
        map((res: any) => new UpdateProductConfigurationSuccess(res)),
        catchError((error) => of(new UpdateProductConfigurationFailure(error)))
      );
    })
  );
}
